import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'DuplicateIcon',
  viewBox: '0 0 16 16',
  defaultProps: {
    boxSize: 4,
  },
  path: (
    <>
      <path
        d="M5.5 3.5C5.5 2.67157 6.17157 2 7 2H9.87868C10.2765 2 10.658 2.15804 10.9393 2.43934L13.0607 4.56066C13.342 4.84196 13.5 5.2235 13.5 5.62132V9.5C13.5 10.3284 12.8284 11 12 11V8.62132C12 7.82567 11.6839 7.06261 11.1213 6.5L9 4.37868C8.43739 3.81607 7.67433 3.5 6.87868 3.5L5.5 3.5Z"
        fill="currentColor"
      />
      <path
        d="M4 5C3.17157 5 2.5 5.67157 2.5 6.5V12.5C2.5 13.3284 3.17157 14 4 14H9C9.82843 14 10.5 13.3284 10.5 12.5V8.62132C10.5 8.2235 10.342 7.84196 10.0607 7.56066L7.93934 5.43934C7.65804 5.15804 7.2765 5 6.87868 5H4Z"
        fill="currentColor"
      />
    </>
  ),
});
